import React, { useEffect, useState } from "react";
import WrapperFiltroSection from "../utilities/WrapperFiltroSection";
import classes from "./FormCategory.module.css";

const fetchConfig = async () => {
  try {
    const response = await fetch('../config.json');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro ao buscar o config:", error);
    return null;
  }
};
const config = await fetchConfig();

const fetchCategories = async () => {
  try {
    const response = await fetch(`${config.url}/catalogo/${config.diretorio}/categorias.json?v=${crypto.randomUUID()}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro ao buscar as categorias:", error);
    return [];
  }
};

const FormCategory = ({ setFilter, filterVal }) => {
  const [selectedCategories, setSelectedCategories] = useState(filterVal);
  const [searchTerm, setSearchTerm] = useState('');
  
  // Estado inicializado com array vazio
  const [allCategories, setAllCategories] = useState([]); // Todas as categorias
  const [filteredCategories, setFilteredCategories] = useState([]); // Categorias filtradas

  // Buscar as categorias ao montar o componente
  useEffect(() => {
    const getCategories = async () => {
      const categories = await fetchCategories();
      const sortedCategories = categories.sort((a, b) => a.localeCompare(b));
      setAllCategories(sortedCategories); // Armazena todas as categorias
      setFilteredCategories(sortedCategories); // Inicializa o estado das categorias filtradas
    };
    getCategories();
  }, []);

  // Filtra as categorias quando o termo de busca é alterado
  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    filterCategories(value);
  };

  // Função para filtrar categorias
  const filterCategories = (term) => {
    const filtered = allCategories.filter(category =>
      category.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredCategories(filtered); // Atualiza as categorias filtradas
  };

  const handleChange = ({ target }) => {
    if (target.checked) {
      setSelectedCategories([...selectedCategories, target.value]);
    } else {
      setSelectedCategories((currValue) => {
        return currValue.filter((val) => val !== target.value);
      });
    }
  };

  useEffect(() => {
    setFilter(selectedCategories);
  }, [selectedCategories, setFilter]);

  useEffect(() => {
    setSelectedCategories(filterVal);
  }, [filterVal]);

  return (
    <WrapperFiltroSection title="Categorias">
      <input
        type="text" 
        className={classes.searchCategory}
        value={searchTerm}
        onChange={handleSearchChange}
        placeholder="Pesquisar categoria"
      />
      <form className={classes.form}>
        {filteredCategories.length > 0 ? (
          filteredCategories.map((category) => (
            <div className={classes.divInput} key={category}>
              <input
                type="checkbox"
                name="categoria"
                id={category}
                value={category}
                onChange={handleChange}
                checked={selectedCategories.includes(category)}
              />
              <label htmlFor={category}>{category}</label>
            </div>
          ))
        ) : (
          <p>Carregando categorias...</p>
        )}
      </form>
    </WrapperFiltroSection>
  );
};

export default FormCategory;
